<template>
  <div>
    <tableFilter
      name="idealsFilters"
      ref="filterComp"
      :activeAmount="activeFilters"
      :mainFunction="getTransactions"
      v-model="filters"
    />

    <div class="card" v-if="logs !== null && logs.length">
      <table width=100%>
        <thead class="table-legend">
          <tr>
            <th>Datum</th>
            <th>ID<br>Transactie</th>
            <th>Bedrag</th>
            <th>Portefeuille / Intake</th>
            <th>Naam<br>IBAN</th>
            <th>Status</th>
          </tr>
        </thead>
        <tr
          v-for="log in logs"
          :key="log.id"
        >
          <td>{{(new Date(log.date)).toLocaleString()}}</td>
          <td>{{log.id}}<br>{{log.ideal}}</td>
          <td>&euro; {{formatPrice(log.amount)}}</td>
          <td>{{log.intake ? `Intake ${log.intake}` : `#${log.port}`}}</td>
          <td>
            {{log.name || 'Onbekend'}}<br>
            {{log.iban || 'Transactie niet voltooid'}} ({{log.issuer}})
          </td>
          <td>{{toStatus(log)}}</td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="totalLogs"
        :resultsPerPage="maxPerPage"
      />
    </div>

    <div v-else-if="logs !== null && !logs.length" class="noresults">
      <span>Geen resultaten</span>
    </div>

    <div v-else class="loader" />
  </div>
</template>

<script>
export default {
  name: 'AdminIdeals',
  data() {
    return {
      logs: [],
      totalLogs: null,
      status: null,
      currentPage: 0,
      maxPerPage: 20,
      activeFilters: [],
      filters: [
        {
          name: 'generalInput',
          model: '',
          cookie: 'idealsGeneralInput',
          filterName: 'search',
          operator: 'contains',
          operators: ['eq', 'neq', 'contains', 'startswith', 'endswith'],
          title: 'Transactie ID, Port, Intake, Naam',
        },
        {
          name: 'currentGroupInput',
          type: 'dropdown',
          position: 'topbar',
          cookie: 'idealsCurrentGroup',
          operator: 'in',
          model: '',
          attributes: [
            {
              name: 'array',
              value: [
                {
                  label: 'Alles',
                  value: 'Alles',
                },
                {
                  label: 'Gelukt',
                  value: 'Gelukt',
                },
                {
                  label: 'Verlopen',
                  value: 'Verlopen',
                },
              ],
            },
            {
              name: 'defaultValue',
              value: 'Gelukt',
            },
            {
              name: 'displayPrefix',
              value: 'Type: ',
            },
            {
              name: 'cb',
              value: () => {
                this.currentPage = 0;
                this.$refs.filterComp.get();
              },
            },
          ],
        },
        {
          name: 'minDate',
          label: 'Vanaf',
          type: 'date',
          model: '',
          cookie: 'idealsMinDateInput',
          filterName: 'date',
          operator: 'gt',
          operators: ['gt'],
          attributes: [
            {
              name: 'max',
              value: this.updateDateLimits('minmax'),
            },
          ],
        },
        {
          name: 'maxDate',
          label: 'Tot',
          type: 'date',
          model: '',
          cookie: 'idealsMaxDateInput',
          filterName: 'date',
          operator: 'lt',
          operators: ['lt'],
          attributes: [
            {
              name: 'min',
              value: this.updateDateLimits('maxmin'),
            },
            {
              name: 'max',
              value: this.updateDateLimits('maxmax'),
            },
          ],
        },
        {
          name: 'idInput',
          label: 'ID',
          type: 'number',
          cookie: 'idealsIdInput',
          model: '',
          filterName: 'id',
          operator: 'eq',
          operators: ['eq', 'neq', 'lt', 'gt'],
        },
        {
          name: 'transactionInput',
          label: 'Transactie ID',
          type: 'text',
          cookie: 'idealsTransactionInput',
          model: '',
          filterName: 'ideal',
          operator: 'contains',
          operators: ['eq', 'neq', 'contains', 'startswith', 'endswith'],
        },
        {
          name: 'portInput',
          label: 'Port',
          type: 'text',
          cookie: 'idealsPortInput',
          model: '',
          filterName: 'port',
          operator: 'eq',
          operators: ['eq', 'neq', 'startswith', 'endswith'],
        },
        {
          name: 'intakeInput',
          label: 'Intake',
          type: 'text',
          cookie: 'idealsIntakeInput',
          model: '',
          filterName: 'intake',
          operator: 'eq',
          operators: ['eq', 'neq', 'lt', 'gt'],
        },
        {
          name: 'amountInput',
          label: 'Bedrag',
          type: 'number',
          cookie: 'idealsAmountInput',
          model: '',
          filterName: 'amount',
          operator: 'eq',
          operators: ['eq', 'neq', 'lt', 'gt', 'eqlt', 'eqgt'],
        },
        {
          name: 'ibanInput',
          label: 'IBAN',
          type: 'text',
          cookie: 'idealsIbanInput',
          model: '',
          filterName: 'iban',
          operator: 'eq',
          operators: ['eq', 'neq', 'contains', 'startswith', 'endswith'],
        },
        {
          name: 'nameInput',
          label: 'Naam gebruiker',
          type: 'text',
          cookie: 'idealsNameInput',
          model: '',
          filterName: 'name',
          operator: 'contains',
          operators: ['eq', 'neq', 'contains', 'startswith', 'endswith'],
        },
      ],
    };
  },
  watch: {
    currentPage() {
      this.$refs.filterComp.get();
    },
  },
  methods: {
    toStatus(log) {
      if (log.status === 1) {
        if (new Date() - new Date(log.date) > 1000 * 60 * 5) {
          return 'Verlopen';
        }
        return 'Bezig';
      }
      if (log.status === 2) {
        return 'Betaald';
      }
      return 'Fout';
    },
    getTransactions(newSearch, filter = '', activeFilters = []) {
      this.logs = null;
      this.activeFilters = activeFilters;
      const currentGroupValue = this.$refs.filterComp.getValue('currentGroupInput');

      if (currentGroupValue) {
        this.createCookie('idealsCurrentGroup', currentGroupValue);
      } else {
        this.eraseCookie('idealsCurrentGroup');
      }

      if (currentGroupValue === 'Gelukt') {
        filter.push('status eq 2');
      }

      if (currentGroupValue === 'Verlopen') {
        filter.push('status neq 2');
      }

      if (this.activeFilters.length) {
        this.$refs.filterComp.toggle(true);
      }

      if (filter.length) {
        filter = filter.join(';');
      }

      if (newSearch) {
        this.currentPage = 0;
      }
      this.sdk.adminIdeals((response) => {
        if (response.status === 200) {
          this.logs = response.data.results;
          this.totalLogs = response.data.totalRows;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      }, filter, this.currentPage, this.maxPerPage);
    },
    updateDateLimits(type) {
      if (type === 'minmax') {
        if (this.maxDate) {
          if (new Date(this.maxDate).getDate() === new Date().getDate()) {
            const newDate = new Date(this.maxDate);
            newDate.setDate(newDate.getDate() - 1);
            return this.formatDate(newDate);
          }
          return this.formatDate(new Date(this.maxDate));
        }
        return this.formatDate(new Date());
      }
      if (type === 'maxmin' && this.minDateInput) {
        return this.formatDate(new Date(this.minDateInput));
      }
      if (type === 'maxmax') {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 1);
        return this.formatDate(currentDate);
      }
      return '';
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() < 9
        ? '0' : ''}${date.getMonth() + 1}-${date.getDate() < 10 ? '0'
        : ''}${date.getDate()}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.menubar {
  height: 40px;
  border-radius: 0;
  padding: 2px;
  input[type=date] {
    width: 140px;
    height: 36px;
    border-radius: 0;
    margin-right: 2px;
    display: inline-block;
    &:first-child {
      border-top-left-radius: 4px;
    }
  }
  span {
    float: none;
  }
  .searchbar {
    float: left;
    height: 36px;
    margin-right: 2px;
    max-width: 500px;
  }
  .dropdown {
    float: none;
    display: inline-block;
  }
  .topbarButton svg {
    padding-bottom: 2px;
  }
}
.filters2 {
  width: 100%;
  height: 0;
  transition: height 0.15s;
  background-color: $color-highlight;
  border-radius: 0;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0;
  &.active {
    height: 122px;
  }
  .filters-inner {
    width: 100%;
    height: 122px;
    padding: 0 2px 2px 0;
    box-sizing: border-box;
    .input {
      width: calc(100% / 5);
      height: 60px;
      padding: 4px 0 0 2px;
      box-sizing: border-box;
      display: inline-flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: column;
      vertical-align: top;
      span {
        padding-left: 3px;
        font-weight: bold;
      }
      input {
        border-radius: 0;
        width: 100% !important;
        height: 36px;
        vertical-align: top;
        width: calc(calc(100% / 5) - 2px);
        &:focus {
          box-shadow: none;
        }
      }
      &.buttons {
        flex-direction: row;
        align-items: flex-end;
        float: right;
        button {
          width: calc(50% - 1px);
          height: 36px;
          border-radius: 0;
          background-color: rgba(0,0,0, 0.1);
          &:hover {
            background-color: rgba(0,0,0, 0.2);
          }
        }
      }
      .userIdInput {
        width: auto !important;
        display: inline-block;
        vertical-align: top;
      }
    }
  }
}
.dropdown-button,
.search-button {
  border-radius: 0;
  float: left;
  margin-right: 2px;
}
.noresults {
  width: 100%;
  height: auto;
  padding: 100px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 20px;
  }
}
</style>
